import React from "react";
import styles from "./ProductItem.module.scss";
import { ButtonArrow, HeartIcon } from "../../../../assets/icons";
import { SolarProductObject } from "../../../../model/solar-product/solar-product-with-recommendations";
import { useNavigate } from "react-router-dom";
import { useCreateWishlistMutation, useDeleteWishlistItemMutation } from "../../../../service/wishlist-service";
import { toast } from "react-toastify";
import { SolarProduct } from "../../../../model/solar-product/solar-product";
import { BounceLoader } from "react-spinners";

type Props = {
	solarProduct: SolarProductObject | undefined;
	onWishlistChange?: (id: string, isWishlisted: boolean) => void;
};

const ProductItem: React.FC<Props> = (props: Props) => {
	const { solarProduct } = props;
	const [addItemToWishlist, { isLoading }] = useCreateWishlistMutation();
	const [removeItem, { isLoading: isRemoveLoading }] = useDeleteWishlistItemMutation();
	const navigate = useNavigate();

	const handleOnClick = (): void => {
		navigate(`/store/item/${solarProduct?.solarProduct.id}`);
		window.scrollTo(0, 0);
	};

	const handleWishList = (product: SolarProduct | null) => {
		if (product?.isWishlisted) {
			removeItem(product?.id ?? "")
				.unwrap()
				.then(() => {
					// toast.success("Product removed from wishlist");
					props?.onWishlistChange && props.onWishlistChange(product?.id ?? "", false);
				})
				.catch(res => toast.error(res?.data?.title as string));
			return;
		}
		addItemToWishlist(product?.id ?? "")
			.unwrap()
			.then(() => {
				// toast.success("Product added to wishlist");
				props?.onWishlistChange && props.onWishlistChange(product?.id ?? "", true);
			})
			.catch(res => toast.error(res?.data?.title as string));
	};

	return (
		<div className={styles.container}>
			<div className={styles.imageContainer}>
				<img src={solarProduct?.solarProduct.images[0].imageUrl} alt="Product" />
				<button
					onClick={() => handleWishList(solarProduct?.solarProduct ?? null)}
					className={`standardButton ${styles.imageButton} ${solarProduct?.solarProduct?.isWishlisted ? styles.active : ""}`}
				>
					{isLoading || isRemoveLoading ? <BounceLoader size={20} /> : <HeartIcon color={solarProduct?.solarProduct?.isWishlisted ? "#FF7926" : "white"} />}
				</button>
			</div>
			<div className={styles.productInfo}>
				<h3 className={styles.name}>{solarProduct?.solarProduct.productName}</h3>
				<div className={styles.productDetails}>
					<p className={styles.description}>Up to {solarProduct?.solarProduct.activeDuration} Hours</p>
					<p className={styles.description}>{solarProduct?.solarProduct.productCapacity} KVA</p>
					<p className={styles.description}>
						{solarProduct?.availableOffers?.reduce((prev, curr) => (curr.months < prev.months ? curr : prev))?.months}-
						{solarProduct?.availableOffers?.reduce((prev, curr) => (curr.months > prev.months ? curr : prev))?.months}
						&nbsp;Months Plan
					</p>
				</div>
			</div>
			<button className={`standardButton ${styles.button}`}>
				From
				<span className={styles.price}>
					₦
					{(
						solarProduct?.solarProduct.price! * 0.3 +
						solarProduct?.availableOffers.sort((a, b) => a.months - b.months)[0].price! *
							solarProduct?.availableOffers.sort((a, b) => a.months - b.months)[0].months!
					).toLocaleString()}
				</span>
				<ButtonArrow />
			</button>
			<button className={`standardButton ${styles.previewBtn}`} onClick={() => handleOnClick()}>
				See Preview
			</button>
		</div>
	);
};

export default ProductItem;
